export enum EntityIdPrefix {
  PAGE = 'page',
  HEADER = 'header',
  FOOTER = 'footer',
  SECTION = 'section',
  ROW = 'row',
  COLUMN = 'column',

  WIDGET = 'widget',
  WIDGET_ELEMENT = 'widget-element',
  WIDGET_SECTION = 'widget-section',

  COLOR = 'color',
  FONT = 'font',
  TEMP_FONT = 'temp_font',
}
